import React from "react"
import { useNavigate } from 'react-router-dom'

import { useEffect } from 'react';
import { setErrorMessage } from "../tools/errorhandling";
import { myData, getMyLinkedhotels, updateEmployeedata, formatdates } from "../dbconnector/connector";
import { useState } from 'react';
import hotelcss from './css/hotelhotellist.module.css';

import EmployeeNode from '../customNodes/EmployeeNode';


const MyData = (props) => {
    const t = props.translation
    const [Edit, setEdit] = useState(true);
    const [myLinkedHotels, setMyLinkedHotels] = useState({});
    const [user, setUser] = useState({});
    const [hotelsarray, setHotelArray] = useState([]);
    // tot hier


    useEffect(() => {
        LoadUser();
    }, []);

    useEffect(() => {
        try {
            setMyLinkedHotels([])
            const mylinkedhotels = getMyLinkedhotels()
            mylinkedhotels.then(res => {
                res.json().then(res => {
                    setHotelArray([]);
                    res.hotels.forEach((item, index) => {
                        setHotelArray(pre => [...pre,
                        <div id={item.Hotel_Id} className={index % 2 === 0 ? hotelcss.hotellinkVarient1_view : hotelcss.hotellinkVarient2_view} >
                            {/* <p>{item.nr_afd}</p> */}
                            <p>{item.Name}</p>
                            <p></p>
                            {/* <input id={item.Hotel_ID} type='CheckBox' className="checkbox" name={item.Hotel_Id} checked={true} disabled={true} ></input> */}
                            <p></p>
                        </div>
                        ])
                    });

                })
            })
        } catch (e) {
            setErrorMessage(t("error_retreivingData"))
        }
        document.getElementById("editDiv").style.display = "grid";
        document.getElementById("saveDiv").style.display = "none";
    }, []);

const LoadUser= ()=> 
{
    setEdit(true);
    myData().then(res => {
        try {

            if (document.getElementById("IconCleaning") !== null)
                document.getElementById("IconCleaning").style.display = "none";
            if (document.getElementById("IconMyData") !== null)
                document.getElementById("IconMyData").style.display = "visible";
            if (document.getElementById("IconMyHoliday") !== null)
                document.getElementById("IconMyHoliday").style.display = "none";
            if (document.getElementById("IconMyContract") !== null)
                document.getElementById("IconMyContract").style.display = "none";

            if (props.rights !== 2) {
                document.getElementById("editDiv").style.display = "none";
                document.getElementById("saveDiv").style.display = "none";
            } else {
                document.getElementById("editDiv").style.display = "grid";
                document.getElementById("saveDiv").style.display = "none";
            }
            setUser({ ...res })

        } catch (e) {
            setErrorMessage(t("error_retreivingData"))
        }

    })


}
    // pappa heeft onderstaande 2 constants toegevoegd zodat de pagina kon renderen
    const onSubmit = (e) => {
        e.preventDefault()
        console.log(user)
        const response = updateEmployeedata({ ...user})
        response.then(res => {
            if (res.status === 200) {
                res.json().then(body => {
                    setEdit(true)
                    document.getElementById("editDiv").style.display = "grid";
                    document.getElementById("saveDiv").style.display = "none";
                })
            } else {
                setErrorMessage(res.statusText)
            }
        })
    }

    const handleEdit = () => {
        setEdit(false)
        document.getElementById("editDiv").style.display = "none";
        document.getElementById("saveDiv").style.display = "grid";
    }

    const changevalue = (e) => {
        setUser((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleCancel = () => {
        LoadUser()
    }

    function formatDateToYYYYMMDD(date) {
        if (date !== null) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
            const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
            return `${year}-${month}-${day}`;
        }
        else {
            return null
        }
    }

    const changedate = (e, datefield) => {
        setUser((prev) => {
            return {
                ...prev,
                [datefield]: formatDateToYYYYMMDD(e)
            }
        })
    }

    return (
        <>
            <div id="main" className="main">
                <header><div id="errordiv" className='error'></div><div className="checkinTime"><div id="timelabel" ></div><div id="time"></div></div></header>
                <EmployeeNode
                    rights={props.rights}
                    translation={props.translation}
                    isDisabled={Edit}
                    hotelsarray={hotelsarray}
                    data={{ user: user }}
                    events={{ changevalue: changevalue, handleEdit: handleEdit, handleCancel: handleCancel, changedate:changedate,setContract: null, openContract: null, setcontractlooptijdvalue: null, setcontracttypevalue: null, navigateback: null, onSubmit: onSubmit }}
                    displaytabs={{ tab1: false, tab2: true, tab3: true, tab4: false, tab5: true, tab6: false, tab7: false, tab8:false, tab9:false }}
                    disabledtabs={{ tab1: false, tab2: false, tab3: false, tab4: false, tab5: false, tab6: false, tab7: false, tab8:false, tab9:false  }}
                    defaulttab="1"
                    viewOnly={true}
                />
            </div>
        </>
    )
}
export default MyData